import { QueryClient } from "@tanstack/react-query"
import { createFileRoute, ParsedLocation, redirect } from "@tanstack/react-router"
import config from "lib/config"
import { authEmployeeQuery } from "modules/auth/lib/authEmployeeQuery"
import { setAuthToken } from "modules/auth/lib/setAuthToken"
import { AuthenticationStatus } from "modules/shared/components/Auth/AuthProvider"
import { useAuth } from "modules/shared/hooks/useAuth"
import "modules/shared/lang"

// NOTE: This is a workaround to be able to coexist supplier portal and _base routes. It's
// used in the __root.tsx file, but defined here as it's where it should be executed.

// eslint-disable-next-line react-refresh/only-export-components
export async function baseBeforeLoad({
  location,
  context,
  search,
}: {
  location: ParsedLocation
  context: {
    queryClient: QueryClient
    auth: ReturnType<typeof useAuth>
  }
  search: Record<string, unknown>
}) {
  if (location.href.startsWith("/c/")) {
    return
  }

  if (location.href.startsWith("/link/")) {
    const hash = location.href.replace("/link/", "").split("?")[0]
    window.location.href = `${config.apiEndpoint}/api/v1/short-link/${hash}`
    return
  }

  if (search && "impersonateToken" in search && typeof search.impersonateToken === "string") {
    setAuthToken({ queryClient: context.queryClient, token: search.impersonateToken })
    throw redirect({ to: "/" })
  }

  if (context.auth.authStatus !== "unknown") {
    if (location.href === "/") {
      const isAuthenticated = context.auth.authStatus === "authenticated"
      const to = isAuthenticated ? "/insights" : "/login"
      throw redirect({ to })
    } else {
      return
    }
  }

  let authStatus: AuthenticationStatus = context.auth.authStatus
  try {
    if (!localStorage.getItem("token")) {
      authStatus = "not_authenticated"
    } else {
      await context.queryClient.fetchQuery(authEmployeeQuery(true))

      authStatus = "authenticated"
    }
  } catch {
    authStatus = "not_authenticated"
  } finally {
    context.auth.authStatus = authStatus
    context.auth.setAuthStatus(authStatus)

    if (location.href === "/") {
      throw redirect({
        to: authStatus === "authenticated" ? "/insights" : "/login",
      })
    }
  }
}

export const Route = createFileRoute("/_base")()
